import { default as rtextInit, JsTextEngine } from "../../core/pkg/rtext.js";
export * from "../gen/types.js";
export * from "./types.js";
export const init = async url => {
  await rtextInit(url);
  let engine = new JsTextEngine();
  return {
    process: async requests => {
      let req = JSON.stringify(requests);
      let engine_clone = engine.create_clone();
      let r = await engine_clone.process(req);
      // This destroys engine_clone along the way
      return r;
    }
  };
};